import { useNavigate } from 'react-router-dom';
import AnimatingDots from '~/components/AnimatingDots';
import Text from '~/components/Text';
import Gap from '~/components/Gap';
import Button from '~/components/Button';
import Divider from '~/components/Divider';
import { useVerifyEmail } from './useVerifyEmail';
import { LOGIN_ROUTE } from '~/constants/routes';

const VerifyEmail = () => {
  const { msg, loading } = useVerifyEmail();
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate(LOGIN_ROUTE);
  };

  return (
    <div className="full-view-dimensions v-center">
      {loading ? <AnimatingDots /> : <Text size="md">{msg}</Text>}
      <Gap t={24} />

      <Divider margin="32px 0" />
      <div className="full-width v-center spread align-center">
        <Button onClick={handleLoginRedirect} variant="secondary">
          Continue
        </Button>
      </div>
    </div>
  );
};

export default VerifyEmail;
